import {useOnMount} from 'shared/web';

import type {FormToDataGridConnectorProps} from 'features/eag-grid';

import {ARTICLE_ID_FILTER_KEY} from '../constants/ARTICLE_ID_FILTER_KEY';

interface AbcXyzArticleFilterProps extends FormToDataGridConnectorProps {
  articleId: string;
}

/**
 * Hidden external filter of the row-detail grids: it renders nothing and only hands the article of
 * the clicked row to the grid as the `articleId` filter, the way a visible external filter such as
 * the branch of `report-warehouse-value` hands over its values.
 */
export function AbcXyzArticleFilter(props: AbcXyzArticleFilterProps) {
  useOnMount(() => props.onChange({...props.values, [ARTICLE_ID_FILTER_KEY]: props.articleId}));

  return null;
}
